import React from 'react';

const initialState = {
  category: {
    name: null,
    key: null
  },
  categories: [],
  deals: [],
  loadingAllDeals: false,
  quickViewOpen: false,
  activeDeal: {
    vendor: {}
  },
  relatedDeals: [],
}

const DealContext = React.createContext({
  state: initialState,
  dispatch: () => null
});

const dealReducer = (state, action)  => {
  switch(action.type) {
    case "set_deals":
      return {
        ...state,
        deals: action.payload.deals,
        //category: action.payload.category,
      }

    case "set_categories":
    case "category/load":
      let categories = action.payload.dealCategories;
      let activeCategory = { id: 'all', name: 'All', key: null };

      categories.sort((a,b) => a.name.localeCompare(b.name));
      //categories.unshift({id: null, name: 'All', key: null });

      if (action.payload.categorySlug) {
        activeCategory = categories.find(elem => elem.key == action.payload.categorySlug); 
      }
      console.log(activeCategory);

      return {
        ...state,
        categories: categories,
        category: activeCategory
      }

    case "quickview/open":
      return {
        ...state,
        quickViewOpen: true,
        activeDeal: action.payload.deal,
        relatedDeals: action.payload.relatedDeals
      }

    case "quickview/close":
      return {
        ...state,
        quickViewOpen: false
      }

    case "change_category":
      return {
        ...state,
        deals: action.payload.deals,
        category: action.payload.category
      }
    case "loading/all_deals/started":
      return {
        ...state,
        loadingAllDeals: true,
      }
    case "loading/all_deals/finished":
      return {
        ...state,
        loadingAllDeals: false,
      }

    default:
      return state;
  }
}

const DealProvider = ({children}) => {
  const [state, dispatch] = React.useReducer(dealReducer, initialState);
  const value = [state, dispatch];

  return <DealContext.Provider value={value}>{children}</DealContext.Provider>

}

function useDeal() {
  const context = React.useContext(DealContext)
  if (context === undefined) {
    throw new Error("useDeal must be invoked within a DealProvider")
  }

  return context;
}

export { DealProvider, DealContext, useDeal }

